






























import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { AuthorisedOnly } from "@/lib/decorators";
import { getElement } from "@/lib/elementHelpers";
import { $t } from "@/lib/i18nHelpers";
import { AttachmentFile } from "@/types";
import BaseInputTextarea from "@/components/BaseInputTextarea";
import BaseSpinner from "@/components/BaseSpinner";

@Component({ name: "BaseSendMessage", components: { BaseInputTextarea, BaseSpinner } })
export default class BaseSendMessage extends Vue {
  @Prop({ type: Boolean, default: false })
  public readonly keepFocus!: boolean;

  @Prop({ required: true })
  public readonly sending!: boolean;

  @Prop({ type: Boolean, default: false })
  public readonly transparent!: boolean;

  @Prop({ default: null })
  public readonly files!: AttachmentFile[] | null;

  @Prop({ default: $t("Message") })
  public readonly placeholder!: string;

  @Prop({ type: String })
  public readonly priceAmount!: string | undefined;

  @Prop({ default: "sci-send" })
  public readonly appendIcon!: string;

  @Prop()
  public readonly prependIcon!: string;

  @Prop()
  public readonly prependIconColor!: string;

  @Prop({
    type: Function,
    default: (value: string) => {
      return value.length > 0;
    },
  })
  public allowSend!: (value: string) => boolean;

  public value: string = "";

  public clearInput() {
    this.value = "";
  }

  public inputMessage(v: string) {
    this.value = v;
    this.$emit("input", this.value);
  }

  @AuthorisedOnly
  public sendMessage() {
    if (this.sending || !this.allowSend(this.value.trim()) || (!this.value && !this.files)) {
      return;
    }
    this.$emit("send", this.value.trim(), this.clearInput);
    if (this.keepFocus) {
      try {
        getElement<HTMLInputElement>((this.$refs.baseInput as Vue).$refs.textarea).focus();
      } catch (e) {}
    }
  }
}
